module.exports = __webpack_public_path__ + "cd69432a44770fc32093ae1163ecf140.pdf";